import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TagList from 'src/store/models/TagList';
import Tag from 'src/store/models/Tag';
import Project from 'src/store/models/Project';
import ProjectTagList from 'src/store/models/ProjectTagList';
import { pickerUtils } from 'src/mixins/picker-utils';
import { colorUtils } from 'src/mixins/colors-utils';
export default {
  name: 'TagPicker',
  mixins: [pickerUtils, colorUtils],
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filters: {
      type: Object,
      default: function _default() {
        return {
          project_id: null,
          active: 1
        };
      }
    },
    label: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    labelColor: {
      type: String,
      default: ''
    },
    dense: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    validated: {
      type: Boolean,
      default: true
    },
    disable: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      textFilter: '',
      originalValue: this.value
    };
  },
  computed: {
    selectedVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val.filter(function (val) {
          return !isNaN(val);
        }));
      }
    },
    project: function project() {
      return Project.query().with(['tag_lists', 'tags']).find(this.filters.project_id);
    },
    requiredTagMissing: function requiredTagMissing() {
      return this.project && this.project.requires_tags && this.selectedVal.length === 0 && this.project.tag_usage !== 'NO_TAGS';
    },
    requiredTagListMissing: function requiredTagListMissing() {
      var _this = this;

      return this.tagLists.filter(function (tagList) {
        return _this.isTagListRequired(tagList);
      }).filter(function (tagList) {
        return !_this.hasTagSelected(tagList);
      }).length > 0 && this.project.tag_usage !== 'NO_TAGS';
    },
    tagLists: function tagLists() {
      var _this2 = this;

      return TagList.query().where(function (tagList) {
        // show only tagLists not linked to any integration or tagLists with the same integration_project_id as the current project
        return (!tagList.integration_project_id || _this2.project && _this2.project.integration_int1 === tagList.integration_project_id) && ( // show only tagLists that are active or are already selected
        tagList.is_active === _this2.filters.active || _this2.originalValueHasTagSelected(tagList));
      }) // when filtering tags we should always check for old entries tagIds that are no longer in the project but
      // should be still considered valid
      .where(function (tagList, query) {
        if (_this2.project && _this2.project.tag_usage === 'LINKED_TAGS') {
          query.whereHas('tags', function (query) {
            if (_this2.project && _this2.project.tag_usage === 'LINKED_TAGS') {
              query.whereIdIn(_this2.project.tags.map(function (tag) {
                return tag.tag_id;
              }).concat(_this2.originalValue));
            }

            query.where(function (tag) {
              return tag.is_active === _this2.filters.active || _this2.originalValue.includes(tag.tag_id);
            });
          });
        }
      }).with('tags', function (query) {
        if (_this2.project && _this2.project.tag_usage === 'LINKED_TAGS') {
          query.whereIdIn(_this2.project.tags.map(function (tag) {
            return tag.tag_id;
          }).concat(_this2.originalValue));
        }

        query.where(function (tag) {
          return tag.is_active === _this2.filters.active || _this2.originalValue.includes(tag.tag_id);
        });
      }).orderBy(function (tagList) {
        if (_this2.project) {
          return !_this2.isTagListRequired(tagList) ? 1 : -1;
        }
      }).orderBy('name', 'asc').all().map(function (tagList) {
        tagList.tags = tagList.tags.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        return tagList;
      });
    },
    filteredTagLists: function filteredTagLists() {
      var _this3 = this;

      return this.tagLists.reduce(function (acc, tagList) {
        var visible = true;

        if (_this3.textFilter) {
          visible && (visible = tagList.name.toLowerCase().indexOf(_this3.textFilter.toLowerCase()) > -1);
        }

        var tags = tagList.tags.filter(function (tag) {
          return tag.name.toLowerCase().indexOf(_this3.textFilter.toLowerCase()) > -1;
        });

        if (visible || tags.length > 0) {
          tagList.type = 'tag_list';

          if (!tagList.tags.length) {
            acc.push(_objectSpread({}, tagList), {
              type: 'no-tag',
              list_color: tagList.color,
              list_text_color: tagList.text_color
            });
          } else {
            acc.push.apply(acc, [_objectSpread({}, tagList)].concat(_toConsumableArray(tags.map(function (tag) {
              return _objectSpread(_objectSpread({}, tag), {}, {
                type: 'tag'
              });
            }))));
          }
        }

        return acc;
      }, []);
    }
  },
  methods: {
    onKeyUp: function onKeyUp() {
      var selectedOption = this.$refs.select.options[this.$refs.select.optionIndex];

      if (selectedOption && selectedOption.type === 'tag_list') {
        this.toggleTagListSelected(selectedOption);
      }
    },
    getTagById: function getTagById(tagId) {
      return Tag.query().with('tag_list').find(tagId);
    },
    getTagColor: function getTagColor(tagId) {
      var tag = this.getTagById(tagId);
      if (!tag) return '#fff';
      return tag.integration_code ? tag.color : tag.tag_list.color;
    },
    clearInputValue: function clearInputValue() {
      this.textFilter = '';
    },
    toggleTagSelected: function toggleTagSelected(tag) {
      var newSelectedItems = new Set(this.selectedVal);

      if (newSelectedItems.has(tag.tag_id)) {
        newSelectedItems.delete(tag.tag_id);
      } else {
        newSelectedItems.add(tag.tag_id);
      }

      this.selectedVal = Array.from(newSelectedItems);
    },
    toggleTagListSelected: function toggleTagListSelected(tagList) {
      var newSelectedItems = new Set(this.selectedVal);

      if (this.isTagListSelected(tagList)) {
        tagList.tags.forEach(function (tag) {
          newSelectedItems.delete(tag.tag_id);
        });
      } else {
        tagList.tags.forEach(function (tag) {
          newSelectedItems.add(tag.tag_id);
        });
      }

      this.selectedVal = Array.from(newSelectedItems);
    },
    isTagListRequired: function isTagListRequired(tagList) {
      if (!this.project) return false;
      var tagListPivot = ProjectTagList.find([this.project.project_id, tagList.tag_list_id]);
      return tagListPivot === null || tagListPivot === void 0 ? void 0 : tagListPivot.required;
    },
    originalValueHasTagSelected: function originalValueHasTagSelected(tagList) {
      var _this4 = this;

      return this.originalValue.filter(function (tagId) {
        var tag = _this4.getTagById(tagId);

        if (tag) {
          return tag.tag_list_id === tagList.tag_list_id;
        }
      }).length > 0;
    },
    hasTagSelected: function hasTagSelected(tagList) {
      var _this5 = this;

      return this.selectedVal.filter(function (tagId) {
        var tag = _this5.getTagById(tagId);

        if (tag) {
          return tag.tag_list_id === tagList.tag_list_id;
        }
      }).length > 0;
    },
    isTagListSelected: function isTagListSelected(tagList) {
      var _this6 = this;

      if (tagList.tags.filter(function (tag) {
        return !_this6.isTagSelected(tag.tag_id);
      }).length > 0 && tagList.tags.filter(function (tag) {
        return _this6.isTagSelected(tag.tag_id);
      }).length > 0) {
        return null;
      } else if (!tagList.tags.length) {
        return false;
      } else return !tagList.tags.filter(function (tag) {
        return !_this6.isTagSelected(tag.tag_id);
      }).length > 0;
    },
    isTagSelected: function isTagSelected(tagId) {
      return this.selectedVal.includes(tagId);
    },
    remove: function remove(tagId) {
      var newValue = this.value;

      if (this.value.indexOf(tagId) >= 0) {
        newValue.splice(this.value.indexOf(tagId), 1);
      }

      this.selectedVal = newValue;
    },
    updateData: function updateData(val) {
      this.selectedVal = val;
    }
  }
};